/* eslint-disable */
import React, { useState } from "react";
import {
  Box,
  Heading,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Button,
  Avatar,
  Center,
  useToast,
  Text} from "@chakra-ui/react";
import axios from "axios";

import { useDispatch, useSelector } from "react-redux";
import { actionLoginSuccess } from "../Redux/UserReducer/actionType";
import { showToast } from "../components/SignUp";
import { useNavigate } from 'react-router-dom';
import { useModalToast } from "../context/GlobalModalToast";


const ProfilePage = () => {
  const userStore = useSelector((store) => store.UserReducer);

  const [name, setName] = useState(userStore?.name || "");
  const [email, setEmail] = useState(userStore?.email || "");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const { toast } = useModalToast();
  const navigate = useNavigate();

  const handleSave = () => {
    const obj = {
      name,
      email,
      password: password || undefined};

    const id = userStore?.userId;

    axios
      .patch(`${process.env.REACT_APP_API_URL}/api/auth/update/${id}`, obj)
      .then((res) => {
        dispatch(actionLoginSuccess(res?.data));
        localStorage.setItem(
          "user",
          JSON.stringify({
            email: res.data.user.email,
            name: res.data.user.name,
            role: res.data.user.role,
            token: res.data.token,
            isAuth: true,
            userId: res.data.user._id,
            sector: res.data.user.sector,
            department: res.data.user.department})
        );
        navigate(-1);
        showToast({ toast, message: 'Profile Updated', color: 'green' });
      })
      .catch((err) => {
        showToast({ toast, message: 'Error updating profile', color: 'red' });
        console.log(err);
      });
  };

  return (
    <Box pb="2rem" bg="var(--background)" minH="100vh">

      <Box maxW="500px" mx="auto" p="6" pt="10">
        <Box
          className="glass-card"
          bg="rgba(255,255,255,0.55)"
          backdropFilter="blur(20px)"
          borderRadius="2xl"
          border="1px solid rgba(255,255,255,0.5)"
          boxShadow="var(--shadow-premium)"
          p={8}
        >
          <Center mb={6}>
            <Avatar
              size="2xl"
              name={name}
              bg="purple.500"
              color="white"
              fontWeight="800"
            />
          </Center>

          <Heading mb={2} fontSize="xl" textAlign="center" fontWeight="800" color="gray.800">
            Edit Profile
          </Heading>
          <Text mb={6} textAlign="center" fontSize="sm" color="gray.500">
            {userStore?.role ? `Role: ${userStore.role === 'user' ? 'Employee' : userStore.role.charAt(0).toUpperCase() + userStore.role.slice(1)}` : ""}
            {userStore?.department ? ` · ${userStore.department}` : ""}
          </Text>

          <VStack spacing="4" align="stretch">
            <FormControl isRequired>
              <FormLabel fontWeight="600" fontSize="sm" color="gray.700">Full Name</FormLabel>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                borderRadius="xl"
                bg="white"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel fontWeight="600" fontSize="sm" color="gray.700">Corporate Email</FormLabel>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                borderRadius="xl"
                bg="white"
              />
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="600" fontSize="sm" color="gray.700">New Password (optional)</FormLabel>
              <Input
                type="password"
                placeholder="Leave blank to keep current password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                borderRadius="xl"
                bg="white"
              />
            </FormControl>

            <Button
              mt="4"
              isDisabled={name === "" || email === ""}
              className="premium-gradient hover-lift"
              color="white"
              size="lg"
              borderRadius="xl"
              onClick={handleSave}
            >
              Save Changes
            </Button>
          </VStack>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfilePage;
